// 📁 utils/periodUtils.js

// 🔧 Convertit une valeur en string "YYYY-MM-DD" pour <input type="date">
const toInputDate = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return ""; // invalide
  return d.toLocaleDateString("fr-CA"); // format ISO local-safe
};

// 🔄 Normalise un tableau de périodes pour les inputs HTML <input type="date">
export const normalizePeriodes = (periodes = []) =>
  periodes.map(p => ({
    ...p,
    start: toInputDate(p.start),
    end: toInputDate(p.end),
  }));
